__turbopack_context__.v({
  "addButton": "CCategoryAdvertisement-module__27svVW__addButton",
  "article": "CCategoryAdvertisement-module__27svVW__article",
  "articleBack": "CCategoryAdvertisement-module__27svVW__articleBack",
  "articleBackLink": "CCategoryAdvertisement-module__27svVW__articleBackLink",
  "articleHeader": "CCategoryAdvertisement-module__27svVW__articleHeader",
  "articleMeta": "CCategoryAdvertisement-module__27svVW__articleMeta",
  "articleText": "CCategoryAdvertisement-module__27svVW__articleText",
  "articleTitle": "CCategoryAdvertisement-module__27svVW__articleTitle",
  "body": "CCategoryAdvertisement-module__27svVW__body",
  "card": "CCategoryAdvertisement-module__27svVW__card",
  "cardLink": "CCategoryAdvertisement-module__27svVW__cardLink",
  "cardTitle": "CCategoryAdvertisement-module__27svVW__cardTitle",
  "contactActions": "CCategoryAdvertisement-module__27svVW__contactActions",
  "contactBox": "CCategoryAdvertisement-module__27svVW__contactBox",
  "contactCheckboxRow": "CCategoryAdvertisement-module__27svVW__contactCheckboxRow",
  "contactFieldError": "CCategoryAdvertisement-module__27svVW__contactFieldError",
  "contactFieldsGrid": "CCategoryAdvertisement-module__27svVW__contactFieldsGrid",
  "contactForm": "CCategoryAdvertisement-module__27svVW__contactForm" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["form"],
  "contactFormTitle": "CCategoryAdvertisement-module__27svVW__contactFormTitle",
  "contactFormWrap": "CCategoryAdvertisement-module__27svVW__contactFormWrap",
  "contactRow": "CCategoryAdvertisement-module__27svVW__contactRow",
  "contactTitle": "CCategoryAdvertisement-module__27svVW__contactTitle",
  "empty": "CCategoryAdvertisement-module__27svVW__empty",
  "fieldsGrid": "CCategoryAdvertisement-module__27svVW__fieldsGrid",
  "form": "CCategoryAdvertisement-module__27svVW__form" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["form"],
  "formActions": "CCategoryAdvertisement-module__27svVW__formActions",
  "gallery": "CCategoryAdvertisement-module__27svVW__gallery",
  "galleryBtn": "CCategoryAdvertisement-module__27svVW__galleryBtn",
  "galleryItem": "CCategoryAdvertisement-module__27svVW__galleryItem",
  "galleryThumb": "CCategoryAdvertisement-module__27svVW__galleryThumb",
  "gridSpan2": "CCategoryAdvertisement-module__27svVW__gridSpan2",
  "list": "CCategoryAdvertisement-module__27svVW__list",
  "meta": "CCategoryAdvertisement-module__27svVW__meta",
  "metaItem": "CCategoryAdvertisement-module__27svVW__metaItem",
  "metaLabel": "CCategoryAdvertisement-module__27svVW__metaLabel",
  "more": "CCategoryAdvertisement-module__27svVW__more",
  "resultsSection": "CCategoryAdvertisement-module__27svVW__resultsSection",
  "resultsTitle": "CCategoryAdvertisement-module__27svVW__resultsTitle",
  "root": "CCategoryAdvertisement-module__27svVW__root",
  "searchSection": "CCategoryAdvertisement-module__27svVW__searchSection",
  "searchTitle": "CCategoryAdvertisement-module__27svVW__searchTitle",
  "teaser": "CCategoryAdvertisement-module__27svVW__teaser",
  "thumb": "CCategoryAdvertisement-module__27svVW__thumb",
  "thumbWrap": "CCategoryAdvertisement-module__27svVW__thumbWrap",
  "topActions": "CCategoryAdvertisement-module__27svVW__topActions",
});
